import React from 'react';
import PropTypes from 'prop-types';

import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import Icon from 'app/components/Icon';
import useTrackingsStatus from 'app/hooks/useTrackingsStatus.hook';

export const FormatStatus = ({
  statusKey,
  carrierStatus = null,
  possibleDelay = false
}) => {
  const trackingsStatus = useTrackingsStatus();

  const { color, backgroundColor, translation } = trackingsStatus[statusKey];
  const statusColor = possibleDelay ? '#EF6327' : color;
  const statusBackgroundColor = possibleDelay ? '#FCE7DF' : backgroundColor;
  return (
    <span
      role="none"
      className="bb-trackings__data-table__cell--tag"
      style={{
        backgroundColor: statusBackgroundColor
      }}
    >
      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
      <label
        className="bb-trackings__data-table__cell medium"
        style={{ color: statusColor }}
      >
        {translation}
        {carrierStatus && (
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip>{carrierStatus}</Tooltip>}
          >
            <div className="bb-trackings__data-table__cell--tag-tooltip">
              <Icon size="1x" icon="square-info" color={statusColor} />
            </div>
          </OverlayTrigger>
        )}
      </label>
    </span>
  );
};

FormatStatus.propTypes = {
  statusKey: PropTypes.string.isRequired,
  carrierStatus: PropTypes.string,
  possibleDelay: PropTypes.bool
};
